var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { FadeSection } from "@brushfire/ui";
import { useContext, useEffect, useState } from "react";
import Constants from "../../../../data/constants";
import { GroupsMode, postAttendeeRoutes, Tab } from "../Register";
import { AppFormContext } from "../../../../App";
import AttendeeTypes from "./AttendeeTypes";
import ASTMatrix from "./AttendeeTypes/ASTMatrix";
import Cart from "./Cart";
import CartResult from "./Cart/CartResult";
import GroupButtons from "./Groups/GroupButtons";
import GroupCreate from "./Groups/GroupCreate";
import GroupJoin from "./Groups/GroupJoin";
import GroupManageReminder from "./Groups/GroupManageReminder";
import { useResizeDetector } from "react-resize-detector";
import styled from "styled-components";
import EventDetails from "../EventDetails/EventDetails";
import { useSelector } from "react-redux";
import useWidgetAnalytics from "../../../../hooks/useWidgetAnalytics";
import MyDashboard from "../../PostAttendeeActions/MyDashboard";
import AutoGroup from "./AutoGroup/AutoGroup";
import SignatureResponse from "./SignatureResponse/SignatureResponse";
import { useHistory } from "react-router-dom";
import moment from "moment";
var cartPaths = [
    Constants.Routes.questions,
    Constants.Routes.cart,
    Constants.Routes.checkout,
    Constants.Routes.results,
];
var MatrixSection = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\twidth: 100%;\n\tmin-height: ", "px;\n\n\t&.cartShown {\n\t\topacity: 0;\n\t\tdisplay: none;\n\t}\n"], ["\n\twidth: 100%;\n\tmin-height: ", "px;\n\n\t&.cartShown {\n\t\topacity: 0;\n\t\tdisplay: none;\n\t}\n"])), function (props) { return props.minHeight; });
var CartSection = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\twidth: 100%;\n\tdisplay: none;\n\tmin-height: ", "px;\n\t&.showCart {\n\t\tdisplay: inline-block;\n\t}\n\t&.cartShown {\n\t\toverflow: unset;\n\t}\n"], ["\n\twidth: 100%;\n\tdisplay: none;\n\tmin-height: ", "px;\n\t&.showCart {\n\t\tdisplay: inline-block;\n\t}\n\t&.cartShown {\n\t\toverflow: unset;\n\t}\n"])), function (props) { return props.minHeight; });
var transitionTime = 0.3;
var useTypedSelector = useSelector;
var RegisterFrame = function (props) {
    var _a, _b, _c, _d, _e;
    var _f = __read(useState(cartPaths.includes(props.path)), 2), cartShouldShow = _f[0], setCartShouldShow = _f[1];
    var _g = __read(useState(cartPaths.includes(props.path)), 2), cartIsVisible = _g[0], setCartIsVisible = _g[1];
    var _h = __read(useState(false), 2), cartIsHiding = _h[0], setCartIsHiding = _h[1];
    var _j = __read(useState(0), 2), savedMinHeight = _j[0], setSavedMinHeight = _j[1];
    var groupsMode = props.groupsMode, setGroupsMode = props.setGroupsMode, eventData = props.eventData, headerHeight = props.headerHeight, currentTab = props.currentTab, setCartTotalSeen = props.setCartTotalSeen, emailDirectionsIsOpen = props.emailDirectionsIsOpen, showEmailSuccess = props.showEmailSuccess, setShowEmailSuccess = props.setShowEmailSuccess, typeCode = props.typeCode, sourceAttendee = props.sourceAttendee, setSourceAttendee = props.setSourceAttendee, path = props.path;
    var _k = useResizeDetector(), matrixHeight = _k.height, matrixContent = _k.ref;
    var _l = useResizeDetector(), cartHeight = _l.height, cartContent = _l.ref;
    var cart = useTypedSelector(function (store) { return store.cart; }).cart;
    var kiosk = useTypedSelector(function (store) { return store.utilities; }).kiosk;
    var formikContext = useContext(AppFormContext).formikContext;
    var analytics = useWidgetAnalytics();
    var history = useHistory();
    var isAddons = path === Constants.Routes.addons &&
        ((_a = eventData === null || eventData === void 0 ? void 0 : eventData.addOns.filter(function (a) { return a.isAvailable || a.isInaccessibleDueToAccessCode; })) !== null && _a !== void 0 ? _a : []).length > 0;
    useEffect(function () {
        var _a;
        if ((eventData === null || eventData === void 0 ? void 0 : eventData.isTimeSlot) &&
            [Constants.Routes.tickets, Constants.Routes.register, Constants.Routes.eventStart].includes(props.path) &&
            currentTab === Tab.REGISTER) {
            //redirect back to calendar
            var url = Constants.Routes.calendar
                .replace(":clientKey", eventData.clientKey)
                .replace("/:urlKey?", eventData.urlKey ? "/".concat(eventData.urlKey) : "")
                .replace(":date?", moment(eventData.dates[0].startsAt.local).format("YYYY-MM-DD"))
                .replace(":eventNumber?", eventData.eventNumber.toString())
                .replace("/:sharedCapacityId?", "");
            if (props.path === Constants.Routes.calendar &&
                !(window.parent && ((_a = window.parent) === null || _a === void 0 ? void 0 : _a.location) !== window.location)) {
                window.location.href = url;
            }
            else {
                history.push(url);
            }
        }
        if (cartPaths.includes(props.path)) {
            if (!cartShouldShow) {
                setCartShouldShow(true);
                setTimeout(function () {
                    setCartIsVisible(true);
                }, 50 * transitionTime);
            }
        }
        else {
            if (cartShouldShow) {
                setCartIsHiding(true);
                setCartIsVisible(false);
                setCartShouldShow(false);
                setTimeout(function () {
                    setCartIsHiding(false);
                }, 50 * transitionTime);
            }
        }
    }, [props.path, currentTab]);
    var hideButton = (_c = !!((_b = formikContext === null || formikContext === void 0 ? void 0 : formikContext.status) === null || _b === void 0 ? void 0 : _b.hideButton)) !== null && _c !== void 0 ? _c : false;
    var hideFooter = hideButton && !((_d = cart === null || cart === void 0 ? void 0 : cart.attendees) === null || _d === void 0 ? void 0 : _d.length);
    useEffect(function () {
        var header = document.getElementById("brushfire-theme-header");
        var footer = document.getElementById("brushfire-footer");
        var themeHeaderHeight = 0;
        var footerHeight = 0;
        if (header) {
            themeHeaderHeight = header.offsetHeight;
        }
        if (footer) {
            footerHeight = footer.offsetHeight;
        }
        var minHeight = window.innerHeight -
            (headerHeight !== null && headerHeight !== void 0 ? headerHeight : 0) -
            94 -
            (currentTab === Tab.REGISTER ? (!hideFooter ? 43 : 0) : 14) -
            themeHeaderHeight -
            footerHeight;
        setSavedMinHeight(minHeight);
    }, [matrixHeight, cartHeight, headerHeight, cartShouldShow, currentTab, hideFooter]);
    useEffect(function () {
        if (eventData) {
            analytics.logPageview();
        }
    }, [props.path, eventData]);
    useEffect(function () {
        if ([Constants.Routes.cart, Constants.Routes.checkout].includes(props.path)) {
            setCartTotalSeen(true);
        }
    }, [props.path]);
    useEffect(function () {
        var scriptsAdded = [];
        if (eventData === null || eventData === void 0 ? void 0 : eventData.customHeadCode) {
            var dom = new DOMParser().parseFromString(eventData === null || eventData === void 0 ? void 0 : eventData.customHeadCode, "text/html");
            var scripts = dom.documentElement.querySelectorAll("script");
            scripts.forEach(function (el) {
                if (el === null || el === void 0 ? void 0 : el.src) {
                    var script = document.createElement("script");
                    if (el.hasAttributes()) {
                        for (var i = 0; i < el.attributes.length; i++) {
                            var attr = el.attributes[i];
                            script.setAttribute(attr.name, attr.value);
                        }
                    }
                    //TODO add these in once log helper method is added back
                    // script.addEventListener("load", function() {
                    // 	console.log("Loaded external script");
                    // });
                    // script.addEventListener("error", function() {
                    // 	console.log("Error loading external script");
                    // });
                    document.head.appendChild(script);
                }
                else {
                    if (el.textContent) {
                        try {
                            eval(el.textContent);
                        }
                        catch (e) {
                            console.error("Error executing the following script:");
                            console.error(el.textContent);
                        }
                    }
                }
            });
        }
        return function () {
            scriptsAdded.forEach(function (script) {
                script.remove();
            });
        };
    }, [eventData === null || eventData === void 0 ? void 0 : eventData.customHeadCode]);
    useEffect(function () {
        var scriptsAdded = [];
        if (eventData === null || eventData === void 0 ? void 0 : eventData.customBodyCode) {
            var dom = new DOMParser().parseFromString(eventData === null || eventData === void 0 ? void 0 : eventData.customBodyCode, "text/html");
            var scripts = dom.documentElement.querySelectorAll("script");
            scripts.forEach(function (el) {
                if (el === null || el === void 0 ? void 0 : el.src) {
                    var script = document.createElement("script");
                    if (el.hasAttributes()) {
                        for (var i = 0; i < el.attributes.length; i++) {
                            var attr = el.attributes[i];
                            script.setAttribute(attr.name, attr.value);
                        }
                    }
                    //TODO add these in once log helper method is added back
                    // script.addEventListener("load", function() {
                    // 	console.log("Loaded external script");
                    // });
                    // script.addEventListener("error", function() {
                    // 	console.log("Error loading external script");
                    // });
                    scriptsAdded.push(script);
                    document.body.appendChild(script);
                }
                else {
                    if (el.textContent) {
                        try {
                            eval(el.textContent);
                        }
                        catch (e) {
                            console.error("Error executing the following script:");
                            console.error(el.textContent);
                        }
                    }
                }
            });
        }
        return function () {
            scriptsAdded.forEach(function (script) {
                script.remove();
            });
        };
    }, [eventData === null || eventData === void 0 ? void 0 : eventData.customBodyCode, props.path]);
    useEffect(function () {
        var scriptsAdded = [];
        if (eventData === null || eventData === void 0 ? void 0 : eventData.cartStackCode) {
            var dom = new DOMParser().parseFromString(eventData === null || eventData === void 0 ? void 0 : eventData.cartStackCode, "text/html");
            var scripts = dom.documentElement.querySelectorAll("script");
            scripts.forEach(function (el) {
                if (el === null || el === void 0 ? void 0 : el.src) {
                    var script = document.createElement("script");
                    if (el.hasAttributes()) {
                        for (var i = 0; i < el.attributes.length; i++) {
                            var attr = el.attributes[i];
                            script.setAttribute(attr.name, attr.value);
                        }
                    }
                    scriptsAdded.push(script);
                    document.head.appendChild(script);
                }
            });
        }
        return function () {
            scriptsAdded.forEach(function (script) {
                script.remove();
            });
        };
    }, [eventData === null || eventData === void 0 ? void 0 : eventData.cartStackCode]);
    return (_jsxs("div", __assign({ className: "register-frame pos-relative" }, { children: [_jsx(MatrixSection, __assign({ transitionTime: transitionTime, className: "matrix-section ".concat(cartShouldShow ? "showCart" : "", " ").concat(cartIsVisible ? "cartShown" : "", " ").concat(cartIsHiding ? "cartIsHiding" : ""), minHeight: savedMinHeight }, { children: _jsxs("div", __assign({ ref: matrixContent }, { children: [_jsxs(FadeSection, __assign({ fade: [Tab.REGISTER, Tab.DASHBOARD].includes(currentTab) }, { children: [_jsx(FadeSection, __assign({ fade: currentTab === Tab.REGISTER &&
                                        [
                                            Constants.Routes.tickets,
                                            Constants.Routes.register,
                                            Constants.Routes.autoreg,
                                            Constants.Routes.section,
                                        ].includes(props.path) &&
                                        groupsMode !== undefined &&
                                        (GroupsMode.hide === groupsMode || GroupsMode.noGroups === groupsMode) }, { children: (eventData === null || eventData === void 0 ? void 0 : eventData.isAssigned) ? (_jsx(_Fragment, { children: _jsx(ASTMatrix, __assign({}, props, { groupsMode: groupsMode, setGroupsMode: setGroupsMode })) })) : (_jsx(_Fragment, { children: (eventData === null || eventData === void 0 ? void 0 : eventData.types) && (_jsx(AttendeeTypes, __assign({}, props, { activePaths: [
                                                Constants.Routes.tickets,
                                                Constants.Routes.register,
                                                Constants.Routes.autoreg,
                                                Constants.Routes.section,
                                            ], groupsMode: groupsMode, setGroupsMode: setGroupsMode, attendeeTypeData: eventData.types, sourceAttendee: sourceAttendee, setSourceAttendee: setSourceAttendee, isAddonMatrix: false }))) })) })), _jsx(FadeSection, __assign({ fade: currentTab === Tab.REGISTER && [Constants.Routes.addons].includes(props.path) }, { children: cart && isAddons && (eventData === null || eventData === void 0 ? void 0 : eventData.addOns) && (_jsx(AttendeeTypes, __assign({}, props, { eventData: eventData, path: path, activePaths: [Constants.Routes.addons], groupsMode: GroupsMode.noGroups, setGroupsMode: function () { return null; }, setSourceAttendee: function () { return null; }, attendeeTypeData: eventData.addOns, isAddonMatrix: true }))) })), _jsx(FadeSection, __assign({ fade: [
                                        Constants.Routes.tickets,
                                        Constants.Routes.register,
                                        Constants.Routes.autoreg,
                                        Constants.Routes.section,
                                    ].includes(props.path) && groupsMode === GroupsMode.buttons }, { children: _jsx(GroupButtons, __assign({}, props, { groupsMode: groupsMode, setGroupsMode: setGroupsMode })) })), _jsx(FadeSection, __assign({ fade: [
                                        Constants.Routes.tickets,
                                        Constants.Routes.register,
                                        Constants.Routes.autoreg,
                                        Constants.Routes.section,
                                    ].includes(props.path) && groupsMode === GroupsMode.createGroup }, { children: _jsx(GroupCreate, __assign({}, props, { groupsMode: groupsMode, setGroupsMode: setGroupsMode })) })), _jsx(FadeSection, __assign({ fade: [
                                        Constants.Routes.tickets,
                                        Constants.Routes.register,
                                        Constants.Routes.autoreg,
                                        Constants.Routes.section,
                                    ].includes(props.path) && groupsMode === GroupsMode.joinGroup }, { children: _jsx(GroupJoin, __assign({}, props, { groupsMode: groupsMode, setGroupsMode: setGroupsMode })) })), _jsx(FadeSection, __assign({ fade: props.path === Constants.Routes.resetGroup }, { children: _jsx(GroupManageReminder, __assign({}, props, { groupsMode: groupsMode, setGroupsMode: setGroupsMode })) })), _jsx(FadeSection, __assign({ fade: props.path === Constants.Routes.autogroup }, { children: eventData && _jsx(AutoGroup, { typeCode: typeCode, path: props.path, eventData: eventData }) })), _jsx(FadeSection, __assign({ fade: props.path === Constants.Routes.signature }, { children: eventData && _jsx(SignatureResponse, { path: props.path, eventData: eventData }) })), _jsx(FadeSection, __assign({ fade: postAttendeeRoutes.includes(props.path) }, { children: eventData && (_jsx(MyDashboard, { path: props.path, eventData: eventData, minHeight: savedMinHeight, active: postAttendeeRoutes.includes(props.path) })) }))] })), _jsx(FadeSection, __assign({ fade: currentTab === Tab.DETAILS }, { children: _jsx(EventDetails, { event: eventData, emailDirectionsIsOpen: emailDirectionsIsOpen, showEmailSuccess: showEmailSuccess, setShowEmailSuccess: setShowEmailSuccess, kioskEnabled: (_e = kiosk === null || kiosk === void 0 ? void 0 : kiosk.enabled) !== null && _e !== void 0 ? _e : false, groupsMode: groupsMode, setGroupsMode: setGroupsMode }) }))] })) })), _jsx(FadeSection, __assign({ fade: [Tab.REGISTER, Tab.DASHBOARD].includes(currentTab) }, { children: _jsx(CartSection, __assign({ transitionTime: transitionTime, className: "cart-section ".concat([Constants.Routes.questions, Constants.Routes.addons].includes(props.path) ? "" : "shifted", " ").concat(props.path === Constants.Routes.results ? "cart-results" : "", " ").concat(cartShouldShow ? "showCart" : "", "  ").concat(cartIsVisible ? "cartShown" : ""), minHeight: savedMinHeight }, { children: _jsxs("div", __assign({ ref: cartContent }, { children: [_jsx("div", __assign({ className: "fade-in ".concat(cartIsVisible ? "active" : "", " ").concat(props.path === Constants.Routes.results ? "hide" : "") }, { children: _jsx(Cart, __assign({}, props)) })), _jsx(FadeSection, __assign({ fade: props.path === Constants.Routes.results }, { children: _jsx(CartResult, __assign({}, props)) }))] })) })) }))] })));
};
export default RegisterFrame;
var templateObject_1, templateObject_2;
